import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
const BONUSES = [{
  title: 'BONO #1: Banco de Ejemplos Reales Argentinos',
  description: 'La economía explicada con la vida cotidiana: inflación, dólar, supermercado.',
  image: 'https://cdn.magicpatterns.com/uploads/3v6d1PDC7wcLnd7Prc2d1S/Bono_1_micro_y_macro.png',
  tag: 'Gratis por hoy'
}, {
  title: 'BONO #2: Clases Express para Días Caóticos',
  description: 'Qué dar cuando no tuviste tiempo de preparar nada. Salvavidas pedagógicos.',
  image: 'https://cdn.magicpatterns.com/uploads/qBVgwm2egBfPnprz9CKhqB/Cover_bono_2_micro_y_macro.png',
  tag: 'Gratis por hoy'
}, {
  title: 'BONO #3: Evaluaciones Listas + Rúbricas',
  description: 'Evaluar sin perder horas. Pruebas escritas y trabajos prácticos listos.',
  image: 'https://cdn.magicpatterns.com/uploads/rjQsXWeKVyVxiXDAT69Hoi/BONO_3_MICRO_Y_MACRO.png',
  tag: 'Gratis por hoy'
}, {
  title: 'BONO #4: Mapa Anual de Contenidos',
  description: 'Todo el año de economía en una sola hoja. Secuencia ideal.',
  image: 'https://cdn.magicpatterns.com/uploads/qwgsYajpeinnRXEhdPfYZU/BONO_4_micro_y_macro_(1).png',
  tag: 'Gratis por hoy'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    const section = document.getElementById('purchase-section');
    if (section) {
      const yOffset = -100;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-gradient-to-b from-slate-900 via-blue-900 to-indigo-900 text-white relative overflow-hidden" data-id="element-1">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-2">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full filter blur-3xl animate-pulse" data-id="element-3"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-pulse delay-1000" data-id="element-4"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-5">
        <div className="text-center mb-20" data-id="element-6">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-400 to-orange-500 text-gray-900 px-6 py-3 rounded-full text-sm font-bold mb-6 shadow-2xl animate-bounce" data-id="element-7">
            <Sparkles className="w-5 h-5" data-id="element-8" />
            <span data-id="element-9">OFERTA ESPECIAL</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black mb-6 leading-tight" data-id="element-10">
            Bonos Incluidos{' '}
            <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent" data-id="element-11">
              GRATIS POR HOY
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed" data-id="element-12">
            Llevate estas herramientas exclusivas para potenciar tus clases sin
            costo adicional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12" data-id="element-13">
          {BONUSES.map((bonus, index) => <div key={index} className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border-2 border-white/20 hover:bg-white/15 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl group" data-id="element-14">
              <div className="flex flex-col h-full" data-id="element-15">
                <div className="mb-6 flex justify-between items-start" data-id="element-16">
                  <span className="bg-gradient-to-r from-amber-400 to-orange-500 text-gray-900 text-sm font-bold px-4 py-2 rounded-full shadow-lg animate-pulse" data-id="element-17">
                    🔥 {bonus.tag}
                  </span>
                  <Gift className="text-amber-400 w-8 h-8 group-hover:scale-110 transition-transform" data-id="element-18" />
                </div>

                <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white leading-tight" data-id="element-19">
                  {bonus.title}
                </h3>

                <p className="text-blue-100 mb-8 text-lg leading-relaxed" data-id="element-20">
                  {bonus.description}
                </p>

                <div className="mt-auto flex justify-center" data-id="element-21">
                  <div className="relative w-full max-w-md aspect-square rounded-2xl overflow-hidden shadow-2xl border-4 border-white/30 group-hover:border-amber-400 transition-all duration-500" data-id="element-22">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain bg-white/5 group-hover:scale-105 transition-transform duration-500" data-id="element-23" />
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-16" data-id="element-24">
          <button onClick={scrollToPurchase} className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-gray-900 font-bold py-5 px-10 rounded-full text-xl shadow-2xl hover:shadow-amber-500/50 transition-all transform hover:scale-105 uppercase tracking-wide" data-id="element-25">
            <Sparkles className="w-6 h-6" data-id="element-26" />
            <span data-id="element-27">Quiero los 4 Bonos Gratis</span>
          </button>
        </div>
      </div>
    </section>;
}